import classNames from 'classnames'

import type { ProductHighlightLevel } from '../../types/product'

interface HighlightLevelsProps {
  levels: ProductHighlightLevel[]
}

const MAX_LEVEL = 5

const HighlightLevels = ({ levels }: HighlightLevelsProps) => {
  return (
    <div className="flex flex-col gap-8">
      {levels.map((level) => {
        const {
          currentLevel,
          leftLabel,
          rightLabel,
          technicalInfoLabel,
          technicalInfoValue,
        } = level

        return (
          <div
            key={`${technicalInfoLabel}-${technicalInfoValue}`}
            className="font-inter flex flex-col gap-5"
          >
            <p className="font-medium text-sm  sm:text-base">
              <span className="text-tertiary">{technicalInfoLabel} </span>
              <strong className="text-restructure-primary">
                {technicalInfoValue}
              </strong>
            </p>
            <div className="flex flex-col gap-2 sm:gap-[1.125rem]">
              <ul className="flex gap-1">
                {Array.from({ length: MAX_LEVEL }).map((_, index) => {
                  return (
                    <li
                      key={`${technicalInfoValue}-${index}`}
                      className={classNames(
                        'flex-1 h-[0.375rem] bg-restructure-background-blue ',
                        index + 1 <= currentLevel ? 'opacity-100' : 'opacity-30'
                      )}
                    />
                  )
                })}
              </ul>

              <div className="w-full flex justify-between items-center">
                <small className="text-xs font-normal text-restructure-primary">
                  {leftLabel}
                </small>
                <small className="text-xs font-normal text-restructure-primary">
                  {rightLabel}
                </small>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default HighlightLevels
